import type { SupabaseClient } from '@supabase/supabase-js'

/**
 * Apply tokens or PKCE code from an OAuth deep link / callback URL.
 */
export async function exchangeOAuthCallbackUrl(
  supabase: SupabaseClient,
  url: string
): Promise<{ error: Error | null }> {
  const hashIndex = url.indexOf('#')
  if (hashIndex !== -1) {
    const params = new URLSearchParams(url.substring(hashIndex + 1))
    const access_token = params.get('access_token')
    const refresh_token = params.get('refresh_token')

    if (access_token && refresh_token) {
      const { error } = await supabase.auth.setSession({
        access_token,
        refresh_token
      })
      return { error: error ?? null }
    }
  }

  if (url.includes('code=')) {
    const { error } = await supabase.auth.exchangeCodeForSession(url)
    return { error: error ?? null }
  }

  if (url.includes('access_token=')) {
    const fragment = url.split('#')[1]
    if (!fragment) return { error: null }
    const params = new URLSearchParams(fragment)
    const access_token = params.get('access_token')
    const refresh_token = params.get('refresh_token')
    if (access_token && refresh_token) {
      const { error } = await supabase.auth.setSession({
        access_token,
        refresh_token
      })
      return { error: error ?? null }
    }
  }

  return { error: null }
}
